import React from "react";
import { Users, Lock, ShieldCheck, SlidersHorizontal, Eye } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCockpit } from "./CockpitLayout";
import UserManager from "@/components/UserManager";
import { Card } from "./ui";
import { useI18n } from "@/context/I18nContext";

const VALUES = [
  { icon: Lock, title: "Sichere Zugänge", text: "Jeder Zugang ist passwortgeschützt — mit optionaler Zwei-Faktor-Anmeldung." },
  { icon: ShieldCheck, title: "Rollen & Rechte", text: "Kunden-Admin sieht alles, Mitarbeiter nur die freigegebenen Bereiche." },
  { icon: SlidersHorizontal, title: "Volle Kontrolle", text: "Benutzer jederzeit anlegen, anpassen, deaktivieren oder entfernen." },
  { icon: Eye, title: "Nachvollziehbar", text: "Sie behalten jederzeit den Überblick, wer Zugriff auf Ihr Cockpit hat." },
];

export default function CTeam() {
  const { user } = useAuth();
  const { t } = useI18n();
  const { accent, overview, clientId } = useCockpit();
  const cid = clientId || user?.client_id || overview?.client?.id;
  const isStaff = ["super_admin", "team_member"].includes(user?.role);
  const canManage = isStaff || user?.role === "client";

  if (!canManage) {
    return (
      <div className="fade-in" data-testid="cteam-no-access">
        <Card className="p-8 text-center text-gray-400">
          {t("Die Benutzerverwaltung ist nur für den Kunden-Admin verfügbar.")}
        </Card>
      </div>
    );
  }

  return (
    <div className="fade-in space-y-5" data-testid="cteam-page">
      <div>
        <p className="text-sm font-semibold flex items-center gap-1.5" style={{ color: accent }}><Users className="w-4 h-4" /> {t("Verwaltung")}</p>
        <h1 className="text-[26px] lg:text-[34px] leading-tight font-black tracking-tight mt-1">{t("Team & Benutzer")}</h1>
        <p className="text-sm text-gray-400 mt-1.5 max-w-2xl">{t("Mitarbeiter Ihrer Firma anlegen und Zugriffe steuern — sicher und jederzeit in Ihrer Hand.")}</p>
      </div>

      <UserManager clientId={cid} accent={accent} showStats />

      <Card className="p-5 lg:p-6" data-testid="cteam-values">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
          {VALUES.map((v) => (
            <div key={v.title} className="flex flex-col gap-2">
              <span className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${accent}14`, color: accent }}><v.icon className="w-5 h-5" /></span>
              <div className="font-bold text-[15px]">{t(v.title)}</div>
              <div className="text-sm text-gray-400 leading-relaxed">{t(v.text)}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
